export const popupLinkConfig = {
  closeBtnClass: 'popup-link-close',
};
